import MGSurface from "@/app/app-components/MGSurface/MGSurface";
import { useTranslation } from "react-i18next";
import "./style.css";
import { MGHeading1, MGHeading3 } from "@/components/typography";
import { getAMPMTime } from "@/app/hooks/useDateFormattingUtils";
import config from "@/config";
import { useMemo, useRef } from "react";
import { MGButton, MGLinkButton } from "@/components/buttons";
import { MGTooltip } from "@/components/tooltip";
import PermissionsService from "@/app/services/permissions/PermissionsService";
import PermissionConstants from "@/app/services/permissions/PermissionConstants";
import UserUtils from "@/app/utils/users/user_utils";

export const WelcomeSplash = ({ nextClass, currentUser, showStartClassModal }) => {
  const { t } = useTranslation();
  const welcomeRef = useRef();
  const currentSchoolUser = UserUtils.getCurrentSchoolUser();

  const classes = useMemo(() => {
    const classes = ["mg-home-welcome"];

    const { COLOR_THEME } = config;
    if (COLOR_THEME.toLowerCase() == "edmesh") {
      classes.push("edmesh-homepage");
    } else {
      classes.push("mg-homepage");
    }

    if (document.body.dir === "rtl") {
      classes.push("rtl");
    }
    return classes;
  }, [document.body.dir, config]);

  return (
    <MGSurface>
      <div className={classes.join(" ")} ref={welcomeRef}>
        <h1 className="heading-jumbo">
          {t("Welcome back,")}
          <br />
          {currentUser?.firstname}!
        </h1>

        <br />
        <br />

        {nextClass && (
          <>
            <div>
              <MGHeading1>
                {t("{{%c}} starts at {{%s}}", { "%c" : nextClass?.className, "%s": getAMPMTime(nextClass?.start_time) })}
              </MGHeading1>
            </div>
            <br />
            <div style={{ display: "flex", gap: "var(--mg-spacing-sm)" }}>
              <MGLinkButton variant={"tertiary"} to={`/plan/class/${nextClass.id}`}>
                {t("Plan Class")}
              </MGLinkButton>
              <MGTooltip
                text={
                  !PermissionsService.hasPermission(PermissionConstants.StartClassOutsideSchoolHours) &&
                  !currentSchoolUser?.is_in_session &&
                  t("You do not have permissions to start a class outside of school hours")
                }
                position={"bottom"}
              >
                <MGButton
                  variant="primary"
                  disabled={
                    !PermissionsService.hasPermission(PermissionConstants.StartClassOutsideSchoolHours) &&
                    !currentSchoolUser?.is_in_session
                  }
                  onClick={() => {
                    showStartClassModal({
                      id: nextClass.id,
                      screenShareMode: nextClass.screen_share_enabled,
                      duration: nextClass.duration,
                      className: nextClass.className,
                    });
                  }}
                >
                  {t("Start Class")}
                </MGButton>
              </MGTooltip>
            </div>
          </>
        )}
      </div>
    </MGSurface>
  );
};
